module.exports = __webpack_public_path__ + "static/media/complete_Icon.f76b48e1.gif";